<template>
  <Teleport to="body">
    <div
      class="demo-popup"
      @click="handleClosePopup"
    >
      <div
        class="container"
        @click.stop
      >
        <img
          src="/dist/css/images/icons/simple_shapes/cross.svg"
          class="popup__close"
          alt="Закрыть"
          @click="handleClosePopup"
        >
        <div
          v-if="showDescription"
          class="description-wrapper"
        >
          <!-- ОКВЕДЫ, Новые компании, Дата регистрации -->
          <template v-if="['okved', 'reg_date', 'new'].includes(section)">
            <p class="demo-popup__text">
              Демо-выгрузка формируется после выбора необходимых вам городов и кодов ОКВЭД.
            </p>
            <p class="demo-popup__text">
              Выберите необходимые вам города и коды ОКВЭД в конфигураторе и
              скачайте демо-выгрузку бесплатно.
            </p>
          </template>

          <!-- Поиск по ключевым словам -->
          <template v-else-if="section === 'key_search'">
            <p class="demo-popup__text">
              Чтобы посмотреть примеры компаний – введите ключевые слова и нажмите "Поиск".<br>
              Измените критерии поиска или скачайте статичную демо-выгрузку.
            </p>
          </template>

          <!-- Описание для Базы компаний -->
          <template v-else>
            <p class="demo-popup__text">
              Демо-выгрузка формируется после выбора необходимых вам городов и рубрик.
            </p>
            <p class="demo-popup__text">
              Выберите необходимые вам города и рубрики в конфигураторе
              и скачайте демо-выгрузку бесплатно.
            </p>
          </template>
        </div>

        <template v-else>
          <p
            v-if="section === 'key_search'"
            class="demo-popup__text"
          >
            На этой странице вы видите примеры компаний, которые отображаются по вашему
            поисковому запросу.<br>
            Чтобы оценить формат данных в итоговом файле, вы можете скачать демо-выгрузку.<br>
            Обратите внимание: в демо-файле будут представлены случайные компании
            (не обязательно соответствующие вашему запросу).
          </p>
          <p
            v-else
            class="demo-popup__text"
          >
            По выбранной конфигурации не нашлось компаний.<br>
            Измените критерии поиска или скачайте статичную демо-выгрузку.
          </p>
        </template>

        <div class="demo-popup__link-wrapper">
          <img
            class="demo-popup__link-img"
            src="./img/excel.png"
            alt="icon excel"
          >
          <a
            :href="`/demo/${getFile}`"
            download
            class="demo-popup__link"
          >
            Скачайте <b>статическую демо-базу</b> (для примера, по разным рубрикам).
          </a>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'DemoPopup',

  props: {
    section: {
      type: String,
      default: '',
      required: true,
    },

    showDescription: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['close'],

  computed: {
    getFile() {
      switch (this.section) {
        case 'okved':
          return 'export-base_demo_okved.xlsx';
        case 'new':
        case 'reg_date':
          return 'export-base_demo_new_companies.xlsx';
        case 'key_search':
          return 'company_search_by_key_demo.xlsx';
        default:
          return 'export_base_structure.xlsx';
      }
    },
  },

  mounted() {
    if (this.isOpen) {
      document.body.style.overflow = 'hidden';
    }
  },

  beforeUnmount() {
    document.body.style.overflow = 'auto';
  },

  methods: {
    handleClosePopup() {
      document.body.style.overflow = 'auto';
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.demo-popup {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 40%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 35px;
  background-color: #fff;
  border-radius: 15px;
  color: black;
  font-size: 16px;
}

.description-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.popup__close {
  position: absolute;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.demo-popup__text {
  line-height: 1.2;
}

.demo-popup__link-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.demo-popup__link-img {
  width: 40px;
}

.demo-popup__link {
  color: #1b88c1;
  margin: 0;
}
</style>
